import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardCreateReturnComponent } from './giftcard-create-return.component';
import { ReturnSaveStepModule } from '../../return-invoices/create-return-invoice-stepper/return-save-step/return-save-step.module';
import { PosConfirmationModule } from 'src/app/shared/pos-confirmation/pos-confirmation.module';



@NgModule({
  declarations: [
    GiftcardCreateReturnComponent
  ],
  imports: [
    CommonModule,
    ReturnSaveStepModule,
    PosConfirmationModule
  ]
})
export class GiftcardCreateReturnModule { }
